const RouterConfig = {
  padding: 40,
};

export default RouterConfig;
